import React, { useState, useEffect, useCallback } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import { useAppState, ITwilioResponse } from '../../state';
import { Grid, CircularProgress, Typography, Snackbar } from '@material-ui/core';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { getURLQuery } from '../../utils';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';

export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}

export default function PreJoinScreens() {
  const { code: authenticationToken  } = getURLQuery();
  const { getToken } = useAppState();
  const [twilioObject, setTwilioObject] = useState<ITwilioResponse>();
  const [ isFetching, setIsFetching ] = useState<boolean>(false);
  const [mediaError, setMediaError] = useState<string>();
  const [snakbarOpen, setSnakbarOpen] = useState<boolean>(false);
  const { removeLocalVideoTrack, removeLocalAudioTrack } = useVideoContext()
  const roomNotCreated = 'room_not_created'


  useEffect(() => {
    if (authenticationToken) {
      setIsFetching(true)
      fetchTwilioToken(authenticationToken)
    } else {
      setTwilioObject(undefined);
      removeLocalVideoTrack();
      removeLocalAudioTrack()
    }
  }, [authenticationToken]);

  const fetchTwilioToken = useCallback((token) => {
    token &&
      getToken(token).then((twilioResponse: any) => {
          if (twilioResponse?.message !== 'jwt expired') {
        setIsFetching(false)
        twilioResponse.user_identity && setTwilioObject(twilioResponse);
        if (twilioResponse.token === roomNotCreated) {
          setTimeout(()=>fetchTwilioToken(token), 3000);
        }
        if (!twilioResponse.user_identity) {
        }
		} else {
            alert(
              'Your online visit time has passed.  Please contact your provider to reschedule your telehealth appointment.'
            );
            setMediaError(
              'Your online visit time has passed.  Please contact your provider to reschedule your telehealth appointment.'
            );
            setSnakbarOpen(true);
          }
      });
  }, [getToken]);

  
  // useEffect(()=> {
  //   if(twilioObject.token === roomNotCreated) {
  //     fetchTwilioToken();
  //   }
  // }, [])

  if (isFetching) {
    return (
      <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
        <div>
          <CircularProgress variant="indeterminate" />
        </div>
        <div>
          <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
            Fetching details
          </Typography>
        </div>
      </Grid>
    );
  }

  return (
    <>
	  {snakbarOpen && <Snackbar open={snakbarOpen} onClose={() => setSnakbarOpen(false)} message={mediaError} />}
      {!authenticationToken && <Typography variant="body2" style={{fontWeight:'normal',fontSize:'16px',padding:'10px', textAlign:'center'}}>Contact admin to create new telehealth group session.</Typography>}
      {twilioObject && <DeviceSelectionScreen twilioObject={twilioObject}/>}
    </>
  );
}

